import { Grid } from "@material-ui/core";
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
} from "App/constants";
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import { useState } from "react";
import { MSG_ERROR_TAGIHAN_NULL, urlAddDitanggung } from "../helpers";

const urlDelete = "/ditanggung/delete";

export const deleteDitanggungById = async (id) => {
  try {
    await instance3.post(urlDelete, { id });
    return {
      state: true,
      message: "Berhasil menghapus data",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
    width: "50px",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
    width: "50px",
  },
  {
    id: "keterangan",
    disablePadding: false,
    label: "KETERANGAN",
    align: "left",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "jumlah",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "isbpjs",
    disablePadding: false,
    label: "STATUS BPJS",
    align: "left",
    sort: false,
  },

  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalTambahDitanggung = ({
  setShowModal,
  tagihanID,
  setNewData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const [formData, setFormData] = useState({
    jumlah_bayar2: 0,
    keterangan: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (isNull(tagihanID)) {
      defaultToastError(MSG_ERROR_TAGIHAN_NULL);
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    } else {
      try {
        const res = await instance3.post(urlAddDitanggung, {
          keterangan: formData.keterangan,
          tagihan_id: tagihanID,
          jumlah: convertToValidPrice(formData.jumlah_bayar2),
        });

        if (res.data.status === 200) {
          await setNewData();
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          defaultToastSuccess("Berhasil menambah ditanggung");
        } else {
          defaultToastError(res.data.message);
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        }
        setShowModal(false);
      } catch (error) {
        defaultToastError(error?.response?.data?.message);
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal title={`Tambah Ditanggung`} width='50%' show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={2}>
          <Grid item sm={12}>
            <InputTextMaster
              name='keterangan'
              label='KETERANGAN'
              placeholder='Keterangan'
              id='keterangan'
              value={formData.keterangan}
              onChange={handleChange("keterangan")}
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='jumlah_bayar2'
              label='JUMLAH'
              id='jumlah_bayar2'
              value={formData.jumlah_bayar2}
              onInput={(e) => {
                let val = e.target.value;
                setFormData({
                  ...formData,
                  jumlah_bayar2: formatRupiah(val),
                });
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
